import { gql } from "@apollo/client";
import { PDR_HISTORY_FRAGMENT } from "../fragments";

export const PDR_HISTORY_QUERY = gql`
  query GetPdrHistory {
    currentPerson {
      pdrHistory {
        ...PDRHistoryFragment
      }
    }
  }
  ${PDR_HISTORY_FRAGMENT}
`;
